import { action, observable, makeObservable } from 'mobx';

export interface IOSCount {
    os: string;
    count: number;
}

export interface IStat {
    id: string;
    endTs?: Date;
    startTs?: Date;
    fromDate?: Date;
    toDate?: Date;
    createdOn?: Date;
    data?: {
        edrOsCount?: IOSCount[];
        avOsCount?: IOSCount[];

        monitoredEdrHostCount?: number;
        monitoredAvHostCount?: number;

        alertTotalCount?: number;
        alertStatusCount?: any[];
        alertSourceTypeCount?: any[];
        quarantinedFileStatusCount?: any[];
        edrLicensedDeviceStatus?: any[];

        topHostsByAlert?: any[];

        dwellTimeMdt?: number;
        dwellTimeMttd?: number;
        dwellTimeMttr?: number;

        newAlertCount?: number;
        newHostCount?: number;
    };
}

export interface IStatHistory {
    count?: number;
    startDate?: Date;
    endDate?: Date;
}

export default class StatStore {
    stat: IStat = {
        id: '',
        data: {
            edrOsCount: [],
            avOsCount: [],
            alertStatusCount: [],
            alertSourceTypeCount: [],
            quarantinedFileStatusCount: [],
            topHostsByAlert: [],
            edrLicensedDeviceStatus: []
        }
    };

    constructor(stat: IStat) {
        makeObservable(this, {
            stat: observable,
            update: action
        });

        this.update(stat);
    }

    update(stat: IStat): void {
        const { data, createdOn, fromDate, toDate } = stat;

        this.stat = {
            ...this.stat,
            createdOn,
            fromDate,
            toDate,
            data: {
                ...this.stat.data,
                edrOsCount: this.sortCounts(data?.edrOsCount, 'os'),
                avOsCount: this.sortCounts(data?.avOsCount, 'os'),
                alertStatusCount: this.sortCounts(data?.alertStatusCount, 'status'),
                alertSourceTypeCount: this.sortCounts(data?.alertSourceTypeCount, 'sourceType'),
                quarantinedFileStatusCount: this.sortCounts(data?.quarantinedFileStatusCount, 'status'),
                topHostsByAlert: this.sortCounts(data?.topHostsByAlert, 'hostname'),
                edrLicensedDeviceStatus: this.sortCounts(data?.edrLicensedDeviceStatus, 'status'),

                alertTotalCount: data?.alertTotalCount,
                monitoredEdrHostCount: data?.monitoredEdrHostCount,
                monitoredAvHostCount: data?.monitoredAvHostCount,

                dwellTimeMdt: data?.dwellTimeMdt,
                dwellTimeMttd: data?.dwellTimeMttd,
                dwellTimeMttr: data?.dwellTimeMttr
            }
        };
    }

    private sortCounts(counts: any[] = [], key: string): IOSCount[] {
        return counts
            .filter((i) => i.count > 0)
            .sort((a, b) => {
                if (a[key].toLowerCase() === 'other') return 1;
                if (b[key].toLowerCase() === 'other') return -1;
                else if (a.count === b.count) return 0;
                else return a.count > b.count ? -1 : 1;
            });
    }
}
